import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateCustomerAddress, updateCustomerCore } from '../modules/update_customer_actions';

import CustomerCore from './CustomerCore.jsx';
import CustomerAddress from './CustomerAddress.jsx';

class EnrollUpdateCustomerInfo extends Component {


  constructor(props) {
    super(props);
    this.state = {
      isShowing:       false,
      isUpdating:      false,
      customer: {},
      shipping_address: {}
    };
    this.toggleShowingState = this.toggleShowingState.bind(this);
  }

  componentWillReceiveProps(nextProps){
    if( this.state.isUpdating && nextProps.customer !== this.props.customer ){
      this.setState({
        isUpdating: false,
        customer: {},
        shipping_address: {}
      });
    }
  }

  handleChange( sLabel, sObjectType, event ) {
    let oActiveUpdate       = this.state[ sObjectType ];
    oActiveUpdate[ sLabel ] = event.target.value;
    let oUpdate             = {};
    oUpdate[ sObjectType ]  = oActiveUpdate;
    this.setState( oUpdate );
  }

  updateEnrollmentCustomerInfo(evt){
    evt.preventDefault();
    if( !this.state.isUpdating ){
      this.setState({ isUpdating: true });
      let cUpdate = this.state.customer;
      this.props.dispatch( updateCustomerCore( cUpdate ));
      let oUpdatedAddresses              = {};
      oUpdatedAddresses.shipping_address = this.state.shipping_address;
      this.props.dispatch( updateCustomerAddress( oUpdatedAddresses ) );
    }
  }

  backToPaymentInfo(dispatch){
    dispatch( activeStepPaymentInfo() );
  }

  toggleShowingState() {
    this.setState({isShowing: !this.state.isShowing});
  }

  render() {
    let { dispatch } = this.props;
    return (
      <div className="info-edit-form showing" >

          <div className="half-col left">
            <h4 className="alt2">Account Information</h4>
            <input
              type        = "text"
              onChange    = {this.handleChange.bind( this, 'first_name', 'customer' )}
              placeholder = "First Name"
              value = { this.state.customer.first_name || this.props.customer.first_name}
              name        = "fname"
            />
            <input
              type        = "text"
              onChange    = {this.handleChange.bind( this, 'last_name', 'customer' )}
              placeholder = "Last Name"
              value = { this.state.customer.last_name || this.props.customer.last_name}
              name        = "lname"
            />
            <input
              type        = "email"
              onChange    = {this.handleChange.bind( this, 'email', 'customer' )}
              placeholder = "Email"
              value =  { this.state.customer.email || this.props.customer.email}
              name        = "email"
            />
            <input
              type        = "password"
              onChange    = {this.handleChange.bind( this, 'password', 'customer' )}
              placeholder = "*********"
              name        = "password"
            />
          </div>
          <div className="half-col">
            <h4 className="alt2">Shipping Information</h4>
            <input
              type        = "text"
              onChange    = {this.handleChange.bind( this, 'street', 'shipping_address' )}
              placeholder = "Address"
              value =  { this.state.shipping_address.street || this.props.customer.shipping_address.street}
              name="ship-address"
            />
            <input
              type        = "text"
              onChange    = {this.handleChange.bind( this, 'city', 'shipping_address' )}
              placeholder = "City"
              value = { this.state.shipping_address.city || this.props.customer.shipping_address.city}
              name="ship-city"
            />
            <div className="select-wrapper unselectable">
              <select
                onChange     = {this.handleChange.bind( this, 'state', 'shipping_address' )}
                value = { this.state.shipping_address.state || this.props.customer.shipping_address.state}
                name="ship-state"
              >
                <option value="State" disabled>State</option>
                <option value="AA">AA - Armed Forces Americas</option>
                <option value="AE">AE - Armed Forces Europe</option>
                <option value="AK">AK - Alaska</option>
                <option value="AL">AL - Alabama</option>
                <option value="AP">AP - Armed Forces Pacific</option>
                <option value="AR">AR - Arkansas</option>
                <option value="AZ">AZ - Arizona</option>
                <option value="CA">CA - California</option>
                <option value="CO">CO - Colorado</option>
                <option value="CT">CT - Connecticut</option>
                <option value="DC">DC - District of Columbia</option>
                <option value="DE">DE - Delaware</option>
                <option value="FL">FL - Florida</option>
                <option value="GA">GA - Georgia</option>
                <option value="HI">HI - Hawaii</option>
                <option value="IA">IA - Iowa</option>
                <option value="ID">ID - Idaho</option>
                <option value="IL">IL - Illinois</option>
                <option value="IN">IN - Indiana</option>
                <option value="KS">KS - Kansas</option>
                <option value="KY">KY - Kentucky</option>
                <option value="LA">LA - Lousiana</option>
                <option value="MA">MA - Massachusetts</option>
                <option value="MD">MD - Maryland</option>
                <option value="ME">ME - Maine</option>
                <option value="MI">MI - Michigan</option>
                <option value="MN">MN - Minnesota</option>
                <option value="MO">MO - Missouri</option>
                <option value="MS">MS - Mississippi</option>
                <option value="MT">MT - Montana</option>
                <option value="NC">NC - North Carolina</option>
                <option value="ND">ND - North Dakota</option>
                <option value="NE">NE - Nebraska</option>
                <option value="NH">NH - New Hampshire</option>
                <option value="NJ">NJ - New Jersey</option>
                <option value="NM">NM - New Mexico</option>
                <option value="NV">NV - Nevada</option>
                <option value="NY">NY - New York</option>
                <option value="OH">OH - Ohio</option>
                <option value="OK">OK - Oklahoma</option>
                <option value="OR">OR - Oregon</option>
                <option value="PA">PA - Pennsylvania</option>
                <option value="PR">PR - Puerto Rico</option>
                <option value="RI">RI - Rhode Island</option>
                <option value="SC">SC - South Carolina</option>
                <option value="SD">SD - South Dakota</option>
                <option value="TN">TN - Tennessee</option>
                <option value="TX">TX - Texas</option>
                <option value="UT">UT - Utah</option>
                <option value="VA">VA - Virginia</option>
                <option value="VT">VT - Vermont</option>
                <option value="WA">WA - Washington</option>
                <option value="WI">WI - Wisconsin</option>
                <option value="WV">WV - West Virginia</option>
                <option value="WY">WY - Wyoming</option>
              </select>
            </div>
            <input
              type        = "text"
              onChange    = {this.handleChange.bind( this, 'zip', 'shipping_address' )}
              placeholder = "Zip code"
              value = { this.state.shipping_address.zip || this.props.customer.shipping_address.zip}
              name="ship-zip"
            />
          </div>
          <div className="full-width">
            <button className="btn-primary fat" onClick={this.updateEnrollmentCustomerInfo.bind( this )}>
              { this.state.isUpdating ? "Pending..." : "Update"}
              </button>
            <button className="btn-secondary fat" onClick={this.backToPaymentInfo.bind(this, dispatch)}>Next</button>
          </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer
    };
}

export default connect(mapStateToProps)(EnrollUpdateCustomerInfo);


// WEBPACK FOOTER //
// ./src/components/EnrollUpdateCustomerInfo.jsx